import { render, staticRenderFns } from "./spedilink.vue?vue&type=template&id=7140bb63&scoped=true&"
var script = {}
import style0 from "./spedilink.vue?vue&type=style&index=0&id=7140bb63&scoped=true&lang=css&"
import style1 from "./spedilink.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7140bb63",
  null
  
)

export default component.exports